<template>
    <div class="wrapSQ">
        <!--轮播图-->
        <eazyswiper :type="6"></eazyswiper>
        <div class="content flex-row">
            <!--社区教育-->
            <div class="item-box clearfix">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[41] }}</h2>
                    <a
                        href="javascript:void(0);"
                        @click="
                            goDetail(
                                itemDataOne,
                                $store.state.navlist[4],
                                $store.state.navlist[41]
                            )
                        "
                        class="titleA"
                        >详情&gt;&gt;</a
                    >
                </div>
                <!--公用线-->
                <div
                    @click="
                        goDetail(
                            itemDataOne,
                            $store.state.navlist[4],
                            $store.state.navlist[41]
                        )
                    "
                    class="item-tw-img"
                >
                    <img :src="itemDataOne.image" :alt="itemDataOne.title" />
                </div>
                <div class="item-tw-text">
                    {{
                        itemDataOne.introduction &&
                        itemDataOne.introduction.length > 120
                            ? itemDataOne.introduction.substring(0, 120) + "..."
                            : itemDataOne.introduction
                    }}
                </div>
            </div>
            <!-- 政策法规 -->
            <div class="item-box clearfix">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[42] }}</h2>
                    <a
                        href="javascript:void(0);"
                        @click="goOline(1)"
                        class="titleA"
                        >详情&gt;&gt;</a
                    >
                </div>
                <div @click="goOline(1)" class="item-tw-img">
                    <img :src="itemDataTwo.image" :alt="itemDataTwo.title" />
                </div>
                <div class="item-tw-text">
                    {{
                        itemDataTwo.introduction &&
                        itemDataTwo.introduction.length > 70
                            ? itemDataTwo.introduction.substring(0, 70) + "..."
                            : itemDataTwo.introduction
                    }}
                    <div class="ln-btn" @click="goOline(2)">查看招生科目</div>
                </div>
            </div>
            <!-- 教育动态 -->
            <div class="item-box">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[43] }}</h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                43,
                                $store.state.navlist[4],
                                $store.state.navlist[43]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            item,
                            $store.state.navlist[4] +
                                '<' +
                                $store.state.navlist[43]
                        )
                    "
                    v-for="(item, index) in itemDataThree"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
            <!-- 成果展示 -->
            <div class="item-box">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[44] }}</h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                44,
                                $store.state.navlist[4],
                                $store.state.navlist[44]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            item,
                            $store.state.navlist[4] +
                                '<' +
                                $store.state.navlist[44]
                        )
                    "
                    v-for="(item, index) in itemDataFour"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
			<!-- 在线课程 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[46] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="goZxkc()"
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="goClassDetails(item)"
			        v-for="(item, index) in itemDataFive"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.totalTitle }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
			</div>
			<!-- 线下活动 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[47] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="goXxhd()"
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="goHdxq(item.id)"
			        v-for="(item, index) in itemDataSix"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.offlineCourseTitle }}</span>
			        <span class="zixun-item-time">{{
			            
						item.startTime &&
						    item.startTime.split(" - ")[0]
			        }}</span>
			    </div>
			</div>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "lnjy",
    data() {
        return {
            itemDataOne: {},//简介
            itemDataTwo: {},//招生报名
            itemDataThree: [],//资讯公告
            itemDataFour: [],//成果展示
			itemDataFive: [],//在线课程
			itemDataSix: [],//线下活动
        };
    },
    created() {
        // 老年教育概述
        this.getZixunData(41);
        // 招生信息
        this.getZixunData(42);
        // // 实践活动
        this.getZixunData(43);
        // // 学习服务支持
        this.getZixunData(44);
		// 在线课程
		this.getZxkc();
		// 线下活动
		this.getXxhd();
    },
    methods: {
		 goClassDetails(val) {
		    this.$router.push({
		        name: "classDetails",
		        query: {
		            id: val.id,
		            title: val.totalTitle,
		            t1: "老年教育",
		            t2: "在线课程"
		        }
		    });
		},
		goZxkc(){
			this.$router.push({
			    name: "zxkc",
				query:{classify:2}
			});
		},
		goXxhd(){
			 this.$router.push({
			    name: "xxhd"
			});
		},
		goHdxq(x) {
		    this.$router.push({
		        name: "hdxq",
		        query: {
		            id: x
		        }
		    });
		},
		getXxhd(){
			    let data = {
			        status: 1,
			        isRTTHP: 1
			    };
			    //线下活动
			    this.$ajax({
			        method: "post",
			        url: "homePage/getOfflineActivities",
			        data: data,
			        success: res => {
			            if (res.code == 200) {
			                this.itemDataSix = res.message.records;
			                if (this.itemDataSix.length > 5) {
			                    this.itemDataSix.length=5;
			                }
			            }
			        },
			        error: res => {
			            console.log(res);
			        }
			    });
			
		},
		getZxkc(){
			    //在线课程
			    let data = {
			        current: 1
			    };
			    this.$ajax({
			        method: "post",
			        url: "homePage/getCoursesSeries",
			        data: data,
			        success: res => {
						 res.message.records.length > 5
						    ? (res.message.records.length = 5)
						    : res.message.records;
			            this.itemDataFive = res.message.records;
			        },
			        error: res => {}
			    });
		},
        goList(navId, titleOne, titleTwo) {
            this.$router.push({
                name: "articalList",
                query: {
                    id: navId,
                    t1: titleOne,
                    t2: titleTwo
                }
            });
        },
        goDetail(item, title, titleTwo = "") {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: item.id,
                    t1: title,
                    t2: titleTwo ? titleTwo : ""
                }
            });
        },
        goOline(type) {
            this.$router.push({
                name: "online",
                query: {
                    type: type
                }
            });
        },
        getZixunData(navId, page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: navId,
                    curren: page
                },
                success: res => {
                    if (res.code == 200) {
                        res.message.records.length > 5
                            ? (res.message.records.length = 5)
                            : res.message.records;
                        switch (navId) {
                            case 41:
                                this.itemDataOne = res.message.records[0]
                                    ? res.message.records[0]
                                    : {};
                                break;
                            case 42:
                                this.itemDataTwo = res.message.records[0]
                                    ? res.message.records[0]
                                    : {};
                                break;
                            case 43:
                                this.itemDataThree = res.message.records;
                                break;
                            case 44:
                                this.itemDataFour = res.message.records;
                                break;
// 							case 46:
// 							    this.itemDataFive = res.message.records;
// 							    break;
// 							case 47:
// 							    this.itemDataSix = res.message.records;
// 							    break;
                            default:
                                break;
                        }
                    }
                }
            });
        },
		jump(x){
			if(x==1){
				this.$router.push({name:'zxkc'});
			}else{
				this.$router.push({name:'xxhd'});
			}
		},
    }
};
</script>
<style scoped="scoped" lang="scss">
	.wrapSQ{
		 width: 1000px;
		 margin: 0 auto;
	}
.content {
    width: 1000px;
    margin: 0 auto;
    min-height: 500px;
    margin-top: 40px;
    align-items: flex-start;
    align-content: flex-start;
}
/* 图文盒子 */
.item-box:nth-child(odd) {
    margin-right: 60px;
}
.item-box {
    width: 470px;
    margin-bottom: 50px;
    margin-right: 0;
    border: 0;
    display: inline-block;
    position: relative;
    .item-title {
        color: #595959;
        height: 40px;
        padding: 0;
        justify-content: space-between;
        border-bottom: 2px solid #ddd;
        margin-bottom: 10px;
        h2 {
            position: relative;
            height: 20px;
            line-height: 20px;
            padding: 10px 0;
            border-bottom: 2px solid #6ac0e8;
            display: inline-block;
            z-index: 1;
            font-size: 18px;
            font-weight: bold;
        }
        a {
            line-height: 40px;
            font-size: 16px;
            color: #6ac0e8;
        }
    }
    // 图文信息
    .item-tw-img {
        width: 158px;
        height: 185px;
        float: left;
        margin: 5px 0;
        border: 1px solid #ddd;
        box-sizing: border-box;
        transition: all ease 0.3s;
        overflow: hidden;
        img {
            width: 100%;
            min-height: 100%;
        }
    }
    .item-tw-img:hover {
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    }
    .item-tw-text {
        width: 300px;
        height: 185px;
        float: right;
        margin: 5px 0;
        overflow: hidden;
        line-height: 23px;
        position: relative;
        .ln-btn {
            position: absolute;
            bottom: 2px;
            right: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            padding: 5px 10px;
            cursor: default;
            box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
        }
        .ln-btn:hover {
            box-shadow: 0 0 2px rgba(0, 0, 0, 0.8);
        }
    }
    // 信息
    .zixun-item {
        justify-content: space-between;
        cursor: pointer;
        .zixun-title {
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 5px 0;
            flex: 1;
            overflow: hidden;
        }
        .zixun-item-time {
            float: right;
            font-size: 14px;
            color: #999;
        }
    }
    .zixun-item:hover > .zixun-item-time {
        color: #333 !important;
    }
    .zixun-item:hover > .zixun-title {
        color: #333 !important;
    }
}
.jumpBox{
	width: 150px;
	height: 200px;
	border: 1px solid #ddd;
	display: inline-block;
}
.jumpBox img{
	width: 100%;
	height: 100%;
}
.right{
	margin-left: 690px;
}
</style>


// WEBPACK FOOTER //
// src/components/lnjy/lnjy.vue